import React, { Component } from "react";
import GetTime from "../GetTime.js";
import { Row, Col } from "reactstrap";
import api from "../../utility/api/api.js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { completedViewDetails } from "../../actions/index";
import { NavLink } from "react-router-dom";
class CompletedDataComponent extends Component {
  constructor(props) {
    console.log("delivereddelivered", props);
    super(props);
    this.state = {};
  }
  getDay(datetime) {
    let jobdate = new Date(datetime);
    let date = `${jobdate.getDate()}-${
      jobdate.getMonth() + 1
    }-${jobdate.getFullYear()}`;
    return date;
  }
  viewOrderDetails(id, status) {
    api.completedviewdetails(this, id, status);
  }

  render() {
    var jobs = this.props.jobsobject.reverse();
    console.log("completedJobs", jobs);

    return (
      <div>
        {jobs.map((obj, i) => (
          <div className="spn-jobs-item py-2" key={i}>
            <Row>
              <Col>
                <div>
                  <span className="jid">TRIP ID:</span> {obj.job_id}
                </div>
              </Col>
              <Col className="text-right">
                <i className="icon-calender"></i> {this.getDay(obj.assigned_at)}
              </Col>
            </Row>
            <Row className="py-2 px-4">
              <Col className="text-center py-3">
                <span className="spn-jobs-item-box spn-jobs-item-box_border">
                  <span className="spn-jobs-item-box-number">
                    {obj.order_count}
                  </span>
                  <span className="spn-jobs-item-box-name">Orders</span>
                </span>
              </Col>
              <Col className="text-center  py-3">
                <span className="spn-jobs-item-box">
                  <span className="spn-jobs-item-box-number">
                    {parseInt(obj.box) < 10 && parseInt(obj.box) > 0
                      ? "0" + obj.box
                      : obj.box}
                  </span>
                  <span className="spn-jobs-item-box-name">Bags</span>
                </span>
              </Col>
              {/* <Col className="text-center py-3">
                <span className="spn-jobs-item-box">
                  <span className="spn-jobs-item-box-number">
                    {obj.total_order_weight}
                  </span>
                  <span className="spn-jobs-item-box-name">Weight in KG</span>
                </span>
              </Col> */}
            </Row>
            <Row className="completed-detail pb-3">
              <Col className="text-center px-1 completed-detail-status">
                <div>ASSIGNED</div>
                <GetTime time={obj.assigned_at} />
              </Col>
              {obj.status === "cancel" ? (
                " "
              ) : (
                <Col className="text-center px-1 completed-detail-status">
                  <div>STARTED</div>
                  <GetTime time={obj.started_at} />
                </Col>
              )}
              {obj.status === "auto-cancel" || obj.status === "cancel" ? (
                <Col className="text-center px-1 completed-detail-status">
                  <div>CANCELLED</div>
                  <GetTime time={obj.canceled_at} />
                </Col>
              ) : (
                <Col className="text-center px-1 completed-detail-status">
                  <div>FINSIHED</div>
                  <GetTime time={obj.completed_at} />
                </Col>
              )}
              {obj.status === "auto-cancel" || obj.status === "cancel" ? (
                ""
              ) : (
                <Col className="text-center px-1 completed-detail-status">
                  <div>DELIVERED</div>
                  <GetTime time={obj.completed_at} />
                </Col>
              )}
            </Row>
            <Row className="box-shadow">
              <Col className="p-0">
                {obj.status === "auto-cancel" ? (
                  <button
                    className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancelled"
                    id={obj.job_id}
                  >
                    <i className="icon-warning pr-2"></i>AUTO-CANCELLED
                  </button>
                ) : obj.status === "cancel" ? (
                  <button
                    className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancelled"
                    id={obj.job_id}
                  >
                    <i className="icon-warning pr-2"></i>CANCELLED
                  </button>
                ) : (
                  <button
                    className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-picked"
                    id={obj.job_id}
                  >
                    <i className="icon-checked pr-2"></i>DELIVERED
                  </button>
                )}
              </Col>
              <Col className="p-0">
                <NavLink
                  className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-viewdetails"
                  to="/deliveredDetails"
                  onClick={() => this.viewOrderDetails(obj.job_id, obj.status)}
                >
                  {" "}
                  VIEW DETAILS
                </NavLink>
                {/* <button
                  className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-viewdetails"
                  id={obj.job_id}
                  // onClick={()=>this.viewOrderDetails(obj.job_id)}
                >
                  VIEW DETAILS
                </button> */}
              </Col>
            </Row>
          </div>
        ))}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    orderData: state.getcompleteddetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { completedViewDetails: completedViewDetails },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompletedDataComponent);



// WEBPACK FOOTER //
// ./src/components/Completed/CompletedDataComponent.js